import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { DocumentsList } from ".";
export class DocumentsListResponseModel extends GlobalResponseObject{
    data?: DocumentsList[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DocumentsList[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}